<mat-card>
  <app-card-header
    title="Códigos"
    [subtitle]="data?.nombre"
    icono="integration_instructions"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <app-content-card title="Códigos" icon="tag">
      <ng-container
        *ngTemplateOutlet="tablaCodigos; context: { $implicit: data?.codigos }"
      ></ng-container>
    </app-content-card>

    <!-- Códigos de entrada (sólo Tracker) -->
    @if (data?.tipo === 'Tracker' && data?.codigosEntrada?.length > 0) {
      <app-content-card
        title="Códigos de entrada"
        icon="settings_input_component"
      >
        <ng-container
          *ngTemplateOutlet="
            tablaCodigos;
            context: { $implicit: data?.codigosEntrada, entrada: true }
          "
        ></ng-container>
      </app-content-card>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">
      Cerrar
    </button>
  </mat-card-actions>
</mat-card>

<ng-template #tablaCodigos let-codigos let-entrada="entrada">
  @if (codigos?.length) {
    <table class="dcd-tabla">
      <thead>
        <tr>
          <th>Código</th>
          <th>Descripción</th>
          <th>Categoría</th>
        </tr>
      </thead>
      <tbody>
        @for (c of codigos; track $index) {
          <tr>
            <td class="dcd-codigo">{{ c.codigo }}</td>
            <td>
              @if (c.descripcion) {
                {{ c.descripcion }}
              } @else {
                <span class="no-info">Sin descripción</span>
              }
            </td>
            <td>
              @if (c.categoriaEvento) {
                <span class="dcd-categoria">
                  {{ c.categoriaEvento?.nombre }}
                  @if (c.categoriaEvento?.atender) {
                    <mat-icon
                      class="dcd-icono dcd-atender"
                      matTooltip="Se atiende"
                    >
                      sos
                    </mat-icon>
                  }
                  @if (!entrada && data?.tipo === 'Tracker' && c.test) {
                    <mat-icon class="dcd-icono" matTooltip="Prueba">
                      science
                    </mat-icon>
                  }
                </span>
              } @else {
                <span class="no-info">Sin categoría</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <span class="no-info">Sin códigos</span>
  }
</ng-template>
